import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"
import { Autocomplete } from "stimulus-autocomplete"
import ContentLoader from "@stimulus-components/content-loader"
import Clipboard from "@stimulus-components/clipboard"

const application = Application.start()
const controllers = import.meta.glob([
  "./**/*.js",
  "./**/*.ts",
], { eager: true })

application.register("autocomplete", Autocomplete)
application.register("clipboard", Clipboard)
application.register("content-loader", ContentLoader)
registerControllers(application, controllers)
window.Stimulus = application
application.debug = false
